import { getOrThrow } from 'quartz/globalState/api';
import { HISTORY_INSTANCE } from './globalState';

/**
 * Returns the current history instance for the app. This should only be used in exceptional cases where the history
 * instance is not available through React context with `useHistory` or `withRouter`.
 *
 * @example
 * ```ts
 * import { getHistory } from 'quartz/framework/routing/service';
 *
 * const href = getHistory().createHref({ pathname: '/some/path' });
 * ```
 */
export const getHistory = () => getOrThrow(HISTORY_INSTANCE);